import React from 'react';
import { CTAButton } from '../ui/CTAButton';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center pt-20 pb-16 px-4 overflow-hidden bg-gradient-to-b from-[var(--bg-deepest)] to-[var(--bg-primary)]" data-id="element-49">
      {/* Static ambient dots */}
      <div className="absolute inset-0 pointer-events-none z-0" data-id="element-50">
        {Array.from({
        length: 15
      }).map((_, i) => <div key={i} className="absolute rounded-full bg-white/10" style={{
        top: `${(i * 7 + 13) % 100}%`,
        left: `${(i * 11 + 5) % 100}%`,
        width: i % 3 + 1,
        height: i % 3 + 1
      }} data-id="element-51" />)}
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-52">
        <div data-id="element-53">
          <span className="inline-block px-4 py-1.5 mb-8 text-sm font-medium tracking-wider text-[var(--accent-teal)] bg-[var(--accent-teal-dim)]/10 rounded-full border border-[var(--accent-teal-dim)]/20" style={{
          fontSize: '32px',
          fontWeight: '700'
        }} data-id="element-54">
            3AM CLUB
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif leading-tight mb-6 text-[var(--text-primary)]" data-id="element-55">
            Si te despiertas a las 3AM… <br className="hidden md:block" data-id="element-56" />
            <span className="text-[var(--text-secondary)]" data-id="element-57">
              no necesitas más consejos.
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-[var(--accent-amber)] font-serif italic mb-12" data-id="element-58">
            Necesitas saber qué hacer.
          </p>
        </div>

        <div className="mb-12 text-left md:text-center space-y-6 text-lg md:text-xl text-[var(--text-secondary)] leading-relaxed" data-id="element-59">
          <p data-id="element-60">
            Hay un tipo de cansancio que no se arregla con "acuéstate temprano".
          </p>
          <p data-id="element-61">
            Es el cansancio de abrir los ojos entre las 2 y las 4am, mirar al
            techo y sentir que tu mente se enciende como si fueran las 11 de la
            mañana.
          </p>
          <p data-id="element-62">
            Y lo peor no es la noche. <br data-id="element-63" />
            Lo peor es lo que te dices después:
          </p>
          <p className="font-serif text-[var(--text-primary)] text-2xl italic" data-id="element-64">
            "Si no me duermo ya… mañana no funciono."
          </p>
          <p data-id="element-65">
            Ahí empieza el ciclo. Y cuando ese ciclo se instala, no lo rompes
            con un té.
          </p>
          <p className="font-bold text-[var(--text-primary)]" data-id="element-66">
            Lo rompes con un protocolo.
          </p>
        </div>

        <div className="mb-12" data-id="element-67">
          <div className="relative w-full max-w-md mx-auto aspect-[4/5] md:aspect-square rounded-2xl overflow-hidden shadow-2xl shadow-[var(--accent-teal-dim)]/10 border border-[var(--bg-card-hover)]" data-id="element-68">
            <img src="https://cdn.magicpatterns.com/uploads/1jq1C9ncd8Lzqzk4ABRW7q/heylloyd-image-1770594370603.png" alt="3AM Club Protocolo en iPad" className="w-full h-full object-cover" data-id="element-69" />
            <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg-deepest)] via-transparent to-transparent opacity-60" data-id="element-70"></div>
          </div>
        </div>

        <div data-id="element-71">
          <CTAButton text="Consigue el Protocolo Ahora" size="xl" href="#final-cta" data-id="element-72" />
          <p className="mt-4 text-sm text-[var(--text-muted)]" data-id="element-73">
            Descarga inmediata • Acceso de por vida
          </p>
        </div>
      </div>
    </section>;
}